import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

const Viewpr_new = () => {
  useAuthRedirect();
  const { prNo } = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/prApproval_detailFinal?prNo=${prNo}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;

          const storeReqHeader = {
            date: items[0].prHeader_date,
            branchCode: items[0].branchCode,
            indenter: items[0].prHeader_hod,
            indentNo: items[0].prHeader_indentNumber,
            fld_requbasis: items[0].prHeader_remarks,
            hm: items[0].prHeader_headMaterial,
            fld_prepared: items[0].fld_prepared,
            remarks: items[0].prHeader_remarks,
          };

          setIndentView(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [prNo]);

  const [supplierCode, setSupplierCode] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [prepareBy, setPrepareBy] = useState("");

  useEffect(() => {
    setLoading(true); // ✅ start loading before API call
    axios
      .get(
        `https://rfs2.infraconsoft.net.in/api/prApproval_detailFinalBottom?prNo=${prNo}&branch1=${indentView.branchCode}&branch=${branch}`
      )
      .then((response) => {
        setData(response.data.bottomDetails);

        if (response.data.bottomDetails.length > 0) {
          setSupplierCode(response.data.bottomDetails[0].supplierMaster_code);
          setSupplierName(response.data.bottomDetails[0].supplierMaster_name);
          setPrepareBy(response.data.bottomDetails[0].prDetail_prepared);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]);
      })
      .finally(() => {
        setLoading(false); // ✅ stop loading after response/error
      });
  }, [prNo, indentView.branchCode, branch]);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Purchase Requisition - View</h2>
            <Link to="/inventory/prview_report">
              <p className="back-button">
                <i className="fa-solid fa-backward"></i>Back
              </p>
            </Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Pr No :</label>
                <input type="text" name="indentNo" value={prNo} readOnly />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
                  type="text"
                  name="endhrs"
                  value={
                    indentView.date
                      ? new Date(indentView.date).toLocaleDateString("en-GB")
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <input
                  type="text"
                  name="indentNo"
                  value={indentView.branchCode}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Prepared By :</label>
                <input type="text" value={prepareBy} name="user" readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Indent Ref :</label>
                <input
                  type="text"
                  name="indentNo"
                  value={indentView.indentNo}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Indenter :</label>
                <input
                  type="text"
                  value={indentView.indenter}
                  name="user"
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input
                  type="text"
                  name="indentNo"
                  value={supplierCode}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input
                  type="text"
                  value={supplierName}
                  name="user"
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input
                  type="text"
                  name="indentNo"
                  value={indentView.remarks}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label>Head Meterial :</label>
                <input type="text" value={indentView.hm} name="user" readOnly />
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Due Date</th>
                    <th>Net Disc</th>
                    <th>Net Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? ( // ✅ show loading
                    <tr>
                      <td colSpan="12" style={{ fontWeight: "bold" }}>
                        Loading...
                      </td>
                    </tr>
                  ) : data.length > 0 ? (
                    (() => {
                      let totalNetAmount = 0;
                      let totalNetTax = 0;
                      let totalFinalAmount = 0;

                      return (
                        <>
                          {data.map((item, index) => {
                            const netamount =
                              item.prDetail_price * item.prDetail_quantity;
                            const netDISC =
                              item.supplierWIdetail_discountPercentage === 0
                                ? 0
                                : (parseFloat(
                                    item.supplierWIdetail_discountPercentage
                                  ) /
                                    100) *
                                  netamount;
                            const minDisc = netamount - netDISC;
                            const netTax =
                              item.SupplierWIDetail_CSTtax === 0
                                ? 0
                                : (parseFloat(item.SupplierWIDetail_CSTtax) /
                                    100) *
                                  minDisc;
                            const totalAmt = minDisc + netTax;

                            totalNetAmount += netamount;
                            totalNetTax += netTax;
                            totalFinalAmount += totalAmt;

                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.prDetail_itemcode}</td>
                                <td>{item.itemmaster_name}</td>
                                <td>{item.itemMaster_purchaseUom}</td>
                                <td>{item.prDetail_price}</td>
                                <td>{item.prDetail_quantity}</td>
                                <td>
                                  {new Date(
                                    item.prDetail_duedate
                                  ).toLocaleDateString("en-GB")}
                                </td>
                                <td>{netDISC.toFixed(2)}</td>
                                <td>{netamount.toFixed(2)}</td>
                              </tr>
                            );
                          })}

                          <tr
                            style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}
                          >
                            <td colSpan="8" style={{ textAlign: "right" }}>
                              Total Price
                            </td>
                            <td>{totalNetAmount.toFixed(2)}</td>
                          </tr>
                          <tr
                            style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}
                          >
                            <td colSpan="8" style={{ textAlign: "right" }}>
                              Total GST
                            </td>
                            <td>{totalNetTax.toFixed(2)}</td>
                          </tr>
                          <tr
                            style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}
                          >
                            <td colSpan="8" style={{ textAlign: "right" }}>
                              Total Amount
                            </td>
                            <td>{totalFinalAmount.toFixed(2)}</td>
                          </tr>
                        </>
                      );
                    })()
                  ) : (
                    <tr>
                      <td colSpan="12">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
        <Link to={`/inventory/prPurchaseReq30_print/${prNo}`}>
          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              <i className="fa-solid fa-print"></i> Print
            </button>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Viewpr_new;
